var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { withSnackbar } from 'notistack';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import { DialogContent, CircularProgress, Typography } from '@material-ui/core';
import { users } from '../../services/api/ava';
import * as segment from '../../utils/segment';
import { updateUser, scribeDeselectTranscriptWord } from '../../actions';
import { getSnack } from '../../utils/snackbar';
import Transition from '../../components/Transition';
class EditProfileModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (ev) => {
            this.setState({ userName: ev.target.value });
        };
        this.submit = (ev) => {
            if (ev) {
                ev.preventDefault();
            }
            // eslint-disable-next-line
            const { close, user, updateUser, t } = this.props;
            const { userName } = this.state;
            if (userName === undefined) {
                close();
                return;
            }
            if (userName === '') {
                getSnack(this.props)(t('profilModal.invalidUserName'), {
                    variant: 'error',
                });
                return;
            }
            this.setState({ submitting: true });
            const { avaId, firebaseAuthUID, id } = user;
            users
                .updateUserName({
                avaId,
                firebaseAuthUID: firebaseAuthUID || id,
                userName,
            })
                .then((res) => {
                this.setState({ submitting: false });
                if (res.status === 200) {
                    updateUser({ userName });
                    getSnack(this.props)(t('profilModal.profilUpdated'), {});
                    close({ updated: true });
                    segment.track('Updated Name', { Name: userName });
                    segment.identify({ name: userName });
                }
                else {
                    getSnack(this.props)(t('profilModal.failToUpdateProfil'), {
                        variant: 'error',
                    });
                    Sentry.captureException('updateProfilError', res.status, res, user);
                }
            });
        };
        this.state = {
            submitting: false,
            userName: undefined,
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line
            const { scribeDeselectTranscriptWord, userNameFromUrl, user } = this.props;
            if (user.userName === 'web guest' && userNameFromUrl) {
                yield this.setState({ userName: userNameFromUrl });
                this.submit();
            }
        });
    }
    componentWillUpdate(nextProps) {
        if (nextProps.open) {
            scribeDeselectTranscriptWord();
        }
    }
    isValid() {
        const { userName } = this.state;
        return userName && userName.length >= 2;
    }
    render() {
        const { action, close, defaultUserName, open, subtitle, t, title, user } = this.props;
        const { submitting } = this.state;
        let defaultNameValue = defaultUserName === undefined ? user.userName : defaultUserName;
        if (defaultNameValue === 'web guest') {
            defaultNameValue = '';
        }
        return (React.createElement("form", { onSubmit: (ev) => {
                this.submit(ev);
            } },
            React.createElement(Dialog, { open: open, TransitionComponent: Transition, onClose: () => close({ updated: false }), PaperProps: {
                    style: {
                        WebkitAppRegion: 'no-drag',
                    },
                } },
                React.createElement(DialogContent, null,
                    React.createElement(Typography, { variant: "h6" }, title || t('profilModal.profilSettings')),
                    React.createElement(Typography, { variant: "subtitle1", style: { color: 'grey' } }, subtitle),
                    React.createElement(Input, { defaultValue: defaultNameValue, onChange: this.handleChange, autoFocus: true, id: "userName", style: { maxWidth: 300, margin: 'auto' }, onFocus: (event) => event.target.select(), onKeyDown: (ev) => {
                            if (['Enter'].includes(ev.key)) {
                                this.submit(ev);
                            }
                        } })),
                React.createElement(DialogActions, null,
                    !submitting && (React.createElement(React.Fragment, null,
                        React.createElement(Button, { variant: "text", onClick: () => close({ updated: false }) }, t('profilModal.cancel')),
                        React.createElement(Button, { disabled: submitting || !this.isValid(), variant: "contained", type: "submit", onClick: this.submit, color: "primary" }, action || t('profilModal.save')))),
                    submitting && React.createElement(CircularProgress, null)))));
    }
}
export default connect(({ scribeSession: { captioner, userNameFromUrl } }) => ({
    user: captioner,
    userNameFromUrl,
}), { updateUser, scribeDeselectTranscriptWord })(withSnackbar(withTranslation()(EditProfileModal)));
